var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "ui large form",
      attrs: { "data-vv-scope": _vm.formScope },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.validateFields(_vm.formScope)
        }
      }
    },
    [
      _c("div", { staticClass: "two fields" }, [
        _c(
          "div",
          {
            staticClass: "field required",
            class: { error: _vm.errors.has(_vm.formScope + ".firstname") }
          },
          [
            _c("label", { attrs: { for: "firstname" } }, [
              _vm._v(_vm._s(_vm.$t("pages.setup.form.firstname")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui input corner labeled" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.firstname,
                    expression: "form.firstname"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: { type: "text", name: "firstname" },
                domProps: { value: _vm.form.firstname },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.form, "firstname", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _vm._m(0)
            ]),
            _vm._v(" "),
            _vm.errors.has(_vm.formScope + ".firstname")
              ? _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(_vm._s(_vm.errors.first(_vm.formScope + ".firstname")))
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "field required",
            class: { error: _vm.errors.has(_vm.formScope + ".lastname") }
          },
          [
            _c("label", { attrs: { for: "lastname" } }, [
              _vm._v(_vm._s(_vm.$t("pages.setup.form.lastname")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui input corner labeled" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.surname,
                    expression: "form.surname"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: { type: "text", name: "lastname" },
                domProps: { value: _vm.form.surname },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.form, "surname", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _vm._m(1)
            ]),
            _vm._v(" "),
            _vm.errors.has(_vm.formScope + ".lastname")
              ? _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(_vm._s(_vm.errors.first(_vm.formScope + ".lastname")))
                ])
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.chunkProperty(_vm.userFields.slice(0, 3), 3), function(
        field,
        index
      ) {
        return _c(
          "div",
          { key: "A" + index, staticClass: "three fields" },
          [
            field[0]
              ? _c("field", {
                  attrs: {
                    field: field[0],
                    scope: _vm.formScope,
                    transparent: false,
                    allowEdit: true
                  },
                  on: { input: _vm.changeFieldValue }
                })
              : _vm._e(),
            _vm._v(" "),
            field[1]
              ? _c("field", {
                  attrs: {
                    field: field[1],
                    scope: _vm.formScope,
                    transparent: false,
                    allowEdit: true
                  },
                  on: { input: _vm.changeFieldValue }
                })
              : _vm._e(),
            _vm._v(" "),
            field[2]
              ? _c("field", {
                  attrs: {
                    field: field[2],
                    scope: _vm.formScope,
                    transparent: false,
                    allowEdit: true
                  },
                  on: { input: _vm.changeFieldValue }
                })
              : _vm._e()
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm._l(_vm.chunkProperty(_vm.userFields.slice(3), 2), function(
        field,
        index
      ) {
        return _c(
          "div",
          { key: "B" + index, staticClass: "two fields" },
          [
            field[0]
              ? _c("field", {
                  attrs: {
                    field: field[0],
                    scope: _vm.formScope,
                    transparent: false,
                    allowEdit: true
                  },
                  on: { input: _vm.changeFieldValue }
                })
              : _vm._e(),
            _vm._v(" "),
            field[1]
              ? _c("field", {
                  attrs: {
                    field: field[1],
                    scope: _vm.formScope,
                    transparent: false,
                    allowEdit: true
                  },
                  on: { input: _vm.changeFieldValue }
                })
              : _vm._e()
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui corner label" }, [
      _c("i", { staticClass: "asterisk icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui corner label" }, [
      _c("i", { staticClass: "asterisk icon" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34bb2081", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34bb2081","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/setup/ProfileSetup.vue
// module id = a+k8
// module chunks = 1